<div *ngIf="languaje === 'en'">
	<li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
		<a class="icon-Combined-Shape-4">Offers</a>
	</li>
	
	<a class="icon-Combined-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Offers</a>
	<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
	
		<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">OFFERS</h2>
	
		<div class="container" [ngClass]="{'show': show_description1}">
		</div>
		
	</div>
</div>



<!--Español-->
<!--Español-->



<div *ngIf="languaje === 'es'">
	<li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
		<a class="icon-Combined-Shape-4">Descuentos</a>
	</li>
	
	<a class="icon-Combined-Shape-4 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Descuentos</a>
	<div class="tab-pane" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">
	
		<h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">DESCUENTOS</h2>
	
		<div class="container" [ngClass]="{'show': show_description1}">
		</div>
		
	</div>
</div>
